// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202512160934/js/" + chunkId + "." + {"44":"df9dd200","225":"de44124c","481":"61713c48","486":"ee5f6313","770":"b291676e"}[chunkId] + ".0.7756965168289132.chunk.js";
};